import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ClientTeamEdit.css';
import {
  getClient,
  getClientForm,
  getInvalidFields,
  getValidationMessage,
} from 'selectors/admin/team/client-team';
import { getCurrentUser } from 'selectors/authentication';
import {
  loadClientRequest,
  submitClientFormRequest,
  updateFormFromCurrentClient,
  updateClientFormValue,
} from 'actions/admin/team/client-team';
import Button from 'components/shared/button/Button';
import Input from 'components/shared/input/Input';
import RadioButton from 'components/shared/radio-button/RadioButton';

class ClientTeamEdit extends Component {
  constructor(props) {
    super(props);
    this.clientId = this.props.currentUser.accountable_id;
  }

  componentDidMount() {
    if (this.props.client === null) {
      // If client not loaded, load it
      this.props
        .dispatch(loadClientRequest(this.clientId))
        .then(() =>
          this.props.dispatch(updateFormFromCurrentClient(this.props.client))
        );
    } else {
      this.props.dispatch(updateFormFromCurrentClient(this.props.client));
    }
  }

  handleFormChange = (attribute, value) => {
    this.props.dispatch(updateClientFormValue(attribute, value));
  };

  handleGlobalPurchaseOrderChange = (value) => {
    this.props.dispatch(
      updateClientFormValue('globalPurchaseOrderRequired', value === 1)
    );
  };

  handlePurchaseOrderChange = (value) => {
    this.props.dispatch(
      updateClientFormValue('purchaseOrderRequired', value === 1)
    );
  };

  handleSubmit = () => {
    this.props.dispatch(
      submitClientFormRequest(this.props.clientForm, this.clientId)
    );
  };

  render() {
    return (
      <div className="client-team-edit">
        <div className="full-title">Edit Client</div>

        <div className="client-team-container">
          <div className="left-side">
            <div className="h2">Client Details</div>
            <div>
              <table className="details-table">
                <tbody>
                  <tr>
                    <td>{this.renderField('Company Name', 'companyName')}</td>
                    <td />
                    <td />
                  </tr>
                </tbody>
              </table>

              <hr />

              <table className="details-table">
                <tbody>
                  <tr>
                    <td>
                      {this.renderField('Contact First Name', 'firstName')}
                    </td>
                    <td colSpan={2}>
                      {this.renderField('Contact Last Name', 'lastName')}
                    </td>
                  </tr>

                  <tr>
                    <td>{this.renderField('Email', 'email')}</td>
                    <td colSpan={2}>
                      {this.renderField('Phone Number', 'phoneNumber')}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      {this.renderField('Street Address', 'streetAddress')}
                    </td>
                    <td colSpan={2}>
                      {this.renderField('Unit number / Floor', 'unitNumber')}
                    </td>
                  </tr>

                  <tr>
                    <td>{this.renderField('City', 'city')}</td>
                    <td>{this.renderField('State', 'state')}</td>
                    <td>{this.renderField('Zip Code', 'zipCode')}</td>
                  </tr>

                  <tr>
                    <td colSpan={3}>
                      <div className="purchase-order-container">
                        <span>Global PO with running balance?</span>
                        <RadioButton
                          className="purchase-order-radio"
                          options={[
                            {
                              value: 1,
                              label: 'Yes',
                            },
                            {
                              value: 0,
                              label: 'No',
                            },
                          ]}
                          value={
                            this.props.clientForm.globalPurchaseOrderRequired
                              ? 1
                              : 0
                          }
                          onChange={this.handleGlobalPurchaseOrderChange}
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan={3}>
                      <div className="purchase-order-container">
                        <span>PO for each work order?</span>
                        <RadioButton
                          className="purchase-order-radio"
                          options={[
                            {
                              value: 1,
                              label: 'Yes',
                            },
                            {
                              value: 0,
                              label: 'No',
                            },
                          ]}
                          value={
                            this.props.clientForm.purchaseOrderRequired ? 1 : 0
                          }
                          onChange={this.handlePurchaseOrderChange}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {this.props.validationMessage !== '' && (
              <div className="invalid-message">
                {this.props.validationMessage}
              </div>
            )}

            <div className="buttons">
              <Button
                className="button-orange"
                label="Save"
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderField(placeholder, attribute) {
    return (
      <Input
        placeholder={placeholder}
        valid={
          this.props.invalidFields.find((element) => element === attribute) ===
          undefined
        }
        value={this.props.clientForm[attribute]}
        onChange={this.handleFormChange.bind(this, attribute)}
      />
    );
  }
}

export default connect((state) => {
  return {
    client: getClient(state),
    clientForm: getClientForm(state),
    currentUser: getCurrentUser(state),
    invalidFields: getInvalidFields(state),
    validationMessage: getValidationMessage(state),
  };
})(ClientTeamEdit);



// WEBPACK FOOTER //
// ./src/components/admin/team/ClientTeamEdit.js